exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upper-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  color: #ffffff;\n  font-size: 12px;\n}\n.upper-row .min {\n  color: rgba(255, 255, 255, 0.75);\n}\n.upper-row .max {\n  color: rgba(255, 255, 255, 0.75);\n}\n.slider /deep/ .ui-slider {\n  height: 16px;\n  background: white;\n  margin: 0 8px 0 8px;\n  box-shadow: 0 0px 3px rgba(0, 0, 0, 0.6) inset;\n}\n.slider /deep/ .ui-slider-handle {\n  margin-top: 2px;\n  cursor: pointer;\n  z-index: 0;\n}\n.slider /deep/ .ui-slider-handle-active {\n  z-index: 1;\n}\n.slider /deep/ .ui-slider-range {\n  z-index: 0;\n  background: #2e97ad;\n}\n.slider /deep/ .ui-slider-horizontal .ui-slider-range {\n  top: 2px;\n  height: calc(100% - 4px);\n  padding: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/components/slider-filter-container/slider-filter-container.component.less
// module id = ../../../../../src/app/packages/menu-items/filters/components/slider-filter-container/slider-filter-container.component.less
// module chunks = main